import React from 'react';
import styled from 'styled-components';
const Footer = styled.footer`
  margin-top: 32px;
  padding: 16px 20px;
  text-align: center;
  color: #e1d6c0;
  border-top: 1px solid #2a2a2a;
  background: transparent;
  font-size: 0.95rem;
`;
const LinkA = styled.a`
  color: #e1d6c0;
  text-decoration: underline;
  &:hover { opacity: 0.85; }
`;
const SiteFooter = () => {
  return (
    <Footer>
      © 2025 Website by Bobs Smart Tech Solutions | All Rights Reserved |
      {' '}Want a website like this?{' '}
      <LinkA href="https://bobssmarttechsolutions.com" target="_blank" rel="noopener noreferrer">
        Click here
      </LinkA>
    </Footer>
  );
};
export default SiteFooter;
